export {
    default as Input,
    type InputProps,
    inputVariants,
    labelVariants,
} from './Input';
